import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "Faqs"
}
const _hoisted_2 = { class: "FaqContent" }
const _hoisted_3 = { class: "FaqListItem" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FaqItem = _resolveComponent("FaqItem")!

  return (!_ctx.isFaqsEmpty && _ctx.isPortalTypeMasters)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "FaqsTitle" }, "Frequently asked questions", -1 /* CACHED */)),
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (faq, i) => {
            return (_openBlock(), _createElementBlock("li", _hoisted_3, [
              _createVNode(_component_FaqItem, {
                id: i,
                question: faq.getQuestion(),
                answer: faq.getAnswer(),
                active: _ctx.isOpened(i).value,
                onToggle: ($event: any) => (_ctx.handleToggle(i))
              }, null, 8 /* PROPS */, ["id", "question", "answer", "active", "onToggle"])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ]))
    : _createCommentVNode("v-if", true)
}